const endpoints = {
  getStatistics: 'api/v2/users/user-id/statistics/',
}

export default endpoints
